import billyTakingNotes from "../Assets/images/billy-taking-notes.png";
import ListItemIcon from "../Assets/icons/list-item-icon.svg";
import RightDownArrow from "../Assets/icons/right-down-arrow.svg";
import LeftDownArrow from "../Assets/icons/left-down-arrow.svg";
import LandingImage from "../Assets/images/landing-image.png";
import ConfettiBackground from "../Assets/images/confetti.png";
import billyPointingPhone from "../Assets/images/billy-pointing-to-phone.png";
import billyPointingReport from "../Assets/images/billy-pointing-to-report.png";
import billyChatting from "../Assets/images/billy-chating.png";
import billyOnRocket from "../Assets/images/billy-on-rocket.png";
import billyOnPiggyBank from "../Assets/images/billy-on-piggy-bank.png";
import PromiseCardLogoWhite from "../Assets/icons/logo-white.png";
import PatternBackground from "../Assets/images/pattern-background.png";
import Person1 from "../Assets/images/person-1.png";
import Person2 from "../Assets/images/person-2.png";
import Person3 from "../Assets/images/person-3.png";
import Person4 from "../Assets/images/person-4.png";
import Person5 from "../Assets/images/person-5.png";
import Person6 from "../Assets/images/person-6.png";
import Person7 from "../Assets/images/person-7.png";
import People from "../Assets/images/people.png";
import RightHandPointingLeft from "../Assets/images/right-hand-pointing-left.png";
import LeftHandSayingOk from "../Assets/images/left-hand-saying-ok.png";

const Images = {
  billyTakingNotes,
  ListItemIcon,
  RightDownArrow,
  LeftDownArrow,
  billyOnPiggyBank,
  LandingImage,
  ConfettiBackground,
  billyPointingPhone,
  billyPointingReport,
  billyChatting,
  billyOnRocket,
  PromiseCardLogoWhite,
  PatternBackground,
  Person1,
  Person2,
  Person3,
  Person4,
  Person5,
  Person6,
  Person7,
  People,
  RightHandPointingLeft,
  LeftHandSayingOk,
};

export default Images;
